export default __webpack_public_path__ + "static/property-asset-442c7ddbf0d78e381433df63f58feb37.jpg";